<dvm-map-viewer [service]="viewer"/>